<template lang="pug">
div
  div.main.hidden-xs-only
    el-table(
      :data='processos',
      v-loading="loading",
      element-loading-text="Carregando..."
    )
      template(slot="empty") Não há registros.
      el-table-column(
        prop='numeroProcesso',
        label='Processo',
        width="130"
      )
      el-table-column(
        prop='nomeRazaoSocialInteressado'
        :label='isIcmBio ? "Nome/razão social do interessado ou nome da UC" : "CPF/CNPJ do interessado:"',
        width="auto"
      )
      el-table-column(
        prop='tipo.nome'
        label='Tipo de processo',
        width="auto"
      )
      el-table-column(
        label='Status',
        prop='status'
        :width="isMA ? 'auto' : 150",
        :formatter="getStatusFormatado",
      )
    br
  div.hidden-sm-and-up
    el-table(
      :data='processos',
      v-loading="loading",
      element-loading-text="Carregando..."
    )
      template(slot="empty") Não há registros.
    div.row(v-for="processo in processos")
      p Processo:
        span {{ processo.numeroProcesso }}
      p Nome/Razão social do interessado:
        span {{ processo.nomeRazaoSocialInteressado }}
      p Tipo de processo:
        span {{ processo.tipo.nome }}
      p Status:
        span {{ processo.status }}
    br
  div.pagination
    el-pagination(
      :page-size="pageSize",
      @current-change="changePage()",
      :current-page.sync="page",
      layout="prev, pager, next",
      :total="totalItems"
    )
</template>
<script>
import EnumFormatter from '@/utils/EnumFormatter'

export default {
  props: {
    processos: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 15
    },
    totalItems: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    loading: {
      Type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isMA: process.env.ESTADO === 'ma',
      isIcmBio: process.env.ESTADO === 'default'
    }
  },
  methods: {
    changePage () {
      return this.$emit('changePage', this.page)
    },
    getTipoFormatado (row) {
      return EnumFormatter.getTipoFormatado(row.tipo)
    },
    getStatusFormatado (row) {
      if (this.isMA) {
        return row.status
      }
      return EnumFormatter.getStatusFormatado(row.status)
    },
    getCpfCnpj (row) {
      if (row.cpfCnpj) {
        return row.cpfCnpj
      }
      return '-'
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/styles/element-variables.scss';
  .main {
    padding-top: 10px;
  }
  .pagination {
    text-align: center;
  }
  .align-center {
    text-align: center;
  }

  .el-table--enable-row-hover .el-table__body tr:hover > td {
    color: $--color-primary !important;
  }

  .el-table--enable-row-hover .el-table__body tr:active > td {
    color: $--color-primary !important;
  }

  .el-table--enable-row-hover .el-table__body tr:link > td {
    color: $--color-primary !important;
  }

  @media screen and (max-width: 1023px) {
    .hidden-sm {
      display: none;
    }
  }

  .row {
    border-bottom: 1px solid #ebeef5;
    font-weight: bold;
    font-size: 12px;
    span {
      margin-left: 5px;
      font-weight: normal;
    }
  }

  .row:first-child {
    border-top: 1px solid #ebeef5;
    margin-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/ListagemProcessos.vue